



































































































































































import Vue, { PropOptions } from 'vue'
import HeaderSearch from '@/common/components/globalHeader/HeaderSearch.vue'
import raksulImg from 'common/icon-app-raksul.svg'
import dmImg from 'common/icon-app-dm.svg'
import designImg from 'common/icon-app-design.svg'
import noveltyImg from 'common/icon-app-novelty.svg'
import estimateImg from 'common/icon-app-estimate.svg'
import apparelImg from 'common/icon-app-apparel.svg'
import { CommonAppData } from '@/common/types/commonAppData'
import { ProductCategory } from '@/model/productCategory'

const MENU_PAGES = {
  MAIN: 'main',
  PARENT_CAT: 'parent_category',
  CHILD_CAT: 'child_category'
}
export default Vue.extend({
  components: {
    HeaderSearch
  },
  props: {
    applicationData: {
      type: Object,
      required: true
    } as PropOptions<CommonAppData>,
    revisionOrderNumber: {
      type: Number,
      required: true
    }
  },
  data(): {
    serviceList: {
      key: string,
      title: string,
      link: string,
      icon: string
    } []
    activeMenu: string
    MENU_PAGES: {[key: string]: string}
    activeParentCategory: number
  } {
    return {
      serviceList: [
        {
          key: 'raksul',
          title: '印刷',
          link: 'https://raksul.com/',
          icon: raksulImg
        },
        {
          key: 'dm',
          title: 'DM',
          link: 'https://dm.raksul.com/',
          icon: dmImg
        },
        {
          key: 'design',
          title: 'デザイン',
          link: 'https://design.raksul.com/',
          icon: designImg
        },
        {
          key: 'novelty',
          title: 'ノベルティ',
          link: 'https://novelty.raksul.com/',
          icon: noveltyImg
        },
        {
          key: 'estimate',
          title: '特注品',
          link: 'https://estimate.raksul.com/',
          icon: estimateImg
        },
        {
          key: 'apparel',
          title: 'アパレル',
          link: 'https://apparel.raksul.com/',
          icon: apparelImg
        }
      ],
      activeMenu: MENU_PAGES.MAIN,
      MENU_PAGES: MENU_PAGES,
      activeParentCategory: -1
    }
  },
  computed: {
    parentCategories(): ProductCategory[] {
      return this.applicationData.product_categories
    },
    childCategories(): ProductCategory[] {
      return this.parentCategories.find(item => item.id === this.activeParentCategory)?.child_categories || []
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    activateMainMenu() {
      this.activeMenu = this.MENU_PAGES.MAIN
    },
    activateParentCategoryMenu() {
      this.activeMenu = this.MENU_PAGES.PARENT_CAT
    },
    onSelectParentCategory(item: ProductCategory) {
      if (item.child_categories && item.child_categories.length > 0) {
        this.activeParentCategory = item.id
        this.activeMenu = this.MENU_PAGES.CHILD_CAT
      } else {
        window.location.href = item.url
      }
    }
  }
})
